// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.successenrollform {
    margin-top: 14%;
}


@media (min-width: 230px) and (max-width: 870px){
    .successenrollform {
        margin-top: 52%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/EnrollFormSuccess.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;;AAGA;IACI;QACI,eAAe;IACnB;AACJ","sourcesContent":[".successenrollform {\n    margin-top: 14%;\n}\n\n\n@media (min-width: 230px) and (max-width: 870px){\n    .successenrollform {\n        margin-top: 52%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
